module.exports = __webpack_public_path__ + "static/media/slider-l3-768.b85b976c.webp";